// extracted by mini-css-extract-plugin
export var container = "HomeV2-module--container--jWEVb";
export var mainCard = "HomeV2-module--mainCard--WCezE";
export var backgroundImage = "HomeV2-module--backgroundImage--qHqpg";
export var content = "HomeV2-module--content--lfGKx";
export var profileHeaderContainer = "HomeV2-module--profileHeaderContainer--l0y-e";
export var profilePhoto = "HomeV2-module--profilePhoto--V4iBo";
export var headerTitle = "HomeV2-module--headerTitle--WXfGx";
export var subHeader = "HomeV2-module--subHeader--lnRph";
export var links = "HomeV2-module--links--pCyJ4";